import { defineNuxtPlugin, useRuntimeConfig } from '#imports'

import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'
import { createIdentificationUniqueId } from '@backmarket/nuxt-module-identification/createIdentificationUniqueId'
import { useVisitorId } from '@backmarket/nuxt-module-identification/useVisitorId'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { toRfc4646Locale } from '@backmarket/utils/string/toRfc4646Locale'

import { useHttpStore } from './composables/useHttpStore'
import { HEADERS } from './constants'
import { createHttpFetch } from './utils/createHttpFetch'

export default defineNuxtPlugin({
  name: 'http-v2-client',
  setup() {
    const config = useRuntimeConfig().public.http2
    const { market } = useMarketplace()
    const locale = useI18nLocale()

    window.$httpFetch = createHttpFetch({
      getDefaultBaseUrl() {
        return config.baseUrlClient.replaceAll('{market.domain}', market.domain)
      },

      getDefaultHeaders(path?: string) {
        const httpStore = useHttpStore()
        const visitorId = useVisitorId()
        const experiments = useExperiments()

        const headers = {
          [HEADERS.ACCEPT_LANGUAGE]: toRfc4646Locale(locale),
          [HEADERS.CSRF_TOKEN]: httpStore.value.csrf ?? '',
          [HEADERS.ENCODING]: 'gzip, deflate',
          [HEADERS.IDENTIFICATION_REQUEST_ID]: createIdentificationUniqueId(),
          [HEADERS.IDENTIFICATION_VISITOR_ID]: visitorId,
          [HEADERS.APP_PLATFORM]: 'web',
        }

        // TODO [CK-6734] Temporary header for checkout service badoom extraction
        // This goes against a lot of separations of concern principles but is an
        // accepted time-limited trade off.
        // This will be removed during Q3 2026.
        if (
          experiments['experiment.checkoutServiceExtraction'] ===
            'useCheckoutService' &&
          path &&
          /^\/bm\/(cart|checkout)/.test(path)
        ) {
          return {
            ...headers,
            'X-Extraction-Source-Of-Truth': 'checkout',
          }
        }

        return headers
      },
    })
  },
})
